<template>
  <settings-group-item
    label="Lead Reviewer"
    description="Administrator of the review"
  >
    <div class="d-flex align-center fill-height">
      <v-menu :disabled="!editable" bottom offset-y>
        <template #activator="{ on, attrs }">
          <!-- Container for the avatar and name, becomes an outlined box when editable -->
          <div
            class="d-flex align-center"
            :class="{ editable }"
            v-bind="attrs"
            v-on="on"
          >
            <!-- Researcher Avatar -->
            <researcher-avatar
              :researcher="leadReviewer.researcher"
            />

            <!-- Lead Reviewer Name -->
            <span class="mx-2 subtitle-2 grey--text text--darken-2">
              {{ leadReviewer.researcher.name }}
            </span>

            <!-- Edit Button (only visible when editable) -->
            <v-btn v-if="editable" icon small>
              <v-icon small class="material-icons-outlined">
                edit
              </v-icon>
            </v-btn>
          </div>
        </template>
        <assign-review-members-popup
          title="Lead Reviewer"
          :assigned-review-members="[leadReviewer]"
          :review-members="allReviewers"
          @assign="$emit('change-lead-reviewer', $event)"
        />
      </v-menu>
    </div>
  </settings-group-item>
</template>

<script>
import ResearcherAvatar from '@/components/Common/ResearcherAvatar';
import SettingsGroupItem from './SettingsGroupItem';
import AssignReviewMembersPopup from './AssignReviewMembersPopup';
import { ReviewMember } from '@/models';
import { typeHelpers } from '@/modules';

export default {
  name: 'LeadReviewMemberSetting',
  components: {
    ResearcherAvatar,
    SettingsGroupItem,
    AssignReviewMembersPopup,
  },
  props: {
    leadReviewer: {
      type: ReviewMember,
      required: true,
    },
    reviewers: {
      type: Array,
      default: () => [],
      validator: (val) =>
        typeHelpers.isArrayOfType(val, ReviewMember),
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change-lead-reviewer'],
  computed: {
    allReviewers() {
      return [this.leadReviewer, ...this.reviewers];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

.editable {
  cursor: pointer;
  user-select: none;

  padding: 8px;
  border: 1px solid map-get($grey, 'lighten-2');
  border-radius: 4px;
}
</style>
